<script lang="ts" setup>
import CategoryCard from "~/entities/catalog/CategoryCard.vue";
import useCatalogStore from "~/shared/store/modules/catalog";
import type {IBrand} from "~/shared/interfaces/brands";

const props = defineProps<{
  cards: IBrand[]
}>()

const catalogStore = useCatalogStore()
</script>

<template>
  <section class="product-categories">
    <div class="container">
      <h2>Категории товаров</h2>
      <div class="product-categories__content">
        <CategoryCard
          v-for="{ name, photoUrl, slug, url } in cards"
          :category-name="name"
          :category-image="photoUrl"
          :category-slug="slug"
          :categoryUrl="url"
          :link-from-catalog="false"
        />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.product-categories {
  &__content {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 24px;
    @include screen(720) {
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 16px;
    }
    @include xs-breakpoint {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
